export const PREVIEW_CARD_SIZE = Object.freeze({
  COMPACT: { label: 'Compact', value: 'compact' },
  FULL: { label: 'Full', value: 'full' },
});

export const DEFAULT_PREVIEW_CARD_SIZE_VALUE = PREVIEW_CARD_SIZE.COMPACT.value;

export const ACTION_MENU_DISPLAY_LIMIT = 5;

export const PREVIEW_CARD_SIZE_SESSION_KEY = 'community-preview-card-size';

export const ACTION_MENU_ITEMS = Object.freeze({
  ARCHIVE: {
    icon: 'archive',
    label: 'Move to Archive',
    payload: { isArchived: true },
    action: 'ARCHIVE',
  },
  UNARCHIVE: {
    icon: 'unarchive',
    label: 'Remove from Archive',
    payload: { isArchived: false },
    action: 'UNARCHIVE',
  },
  READ: {
    icon: 'mail-read',
    label: 'Mark as Read',
    payload: { isRead: true },
    action: 'READ',
  },
  UNREAD: {
    icon: 'mail-unread',
    label: 'Mark as Unread',
    payload: { isRead: false },
    action: 'UNREAD',
  },
  FOLLOWUP: {
    icon: 'bookmark-add',
    label: 'Mark as Follow Up',
    payload: { isFollowUp: true },
    action: 'MARK_AS_FOLLOW_UP',
  },
  UNFOLLOWUP: {
    icon: 'bookmark-remove',
    label: 'Remove Follow Up',
    payload: { isFollowUp: false },
    action: 'REMOVE_FOLLOW_UP',
  },
  ASSIGN: {
    icon: 'user-right',
    label: 'Assign To',
    action: 'ASSIGN',
  },
  TAG: {
    icon: 'tag',
    label: 'Manage Tags',
    action: 'ADD_TAGS',
  },
  HIDE: {
    icon: 'eye-off',
    label: 'Hide Comment',
    action: 'HIDE',
  },
  DELETE: {
    icon: 'delete',
    label: 'Delete Comment',
    class: 'dash-text-danger dash-fill-icon-danger',
    action: 'DELETE',
  },
  BLOCK: {
    icon: 'slash-circle',
    label: 'Block User',
    class: 'dash-text-danger dash-fill-icon-danger',
    action: 'BLOCK',
  },
});

export const EMPTY_STATE_DETAILS = Object.freeze({
  NO_SEARCH_RESULT: {
    variant: 'pageError',
    title: 'No Results Found',
    message: 'Review or adjust your filters to uncover messages that match',
    ctaButton: { label: 'Reset Filters', severity: 'tertiary' },
    center: true,
    icon: 'search',
  },
});

export const SORT_OPTIONS = Object.freeze({
  SOURCE_UPDATED_AT: { label: 'Recently Published', value: 'SOURCE_UPDATED_AT' },
  RELEVANCE: { label: 'Most Relevant', value: 'RELEVANCE', disabledSortOrders: ['ASC'] },
});

export const DEFAULT_SORT_OPTION = Object.freeze({
  sortOrder: 'DESC',
  selected: SORT_OPTIONS.SOURCE_UPDATED_AT,
});
